import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MobileDeviceService } from '@app/services/mobile-device.service';
import { SearchType } from '@search-bar/entities/search-type';
import { CalendarField } from '@shared/base-search-bar/entities/calendar.entities';
import { HotelDetailResponse } from '@hotels/hotel-detail/entities/hotel-detail.response';
import { EVENT_SOURCE } from '@app/modules/core/constants/amplitude.constants';
import { BaseSearchBarFacade } from '@shared/base-search-bar/base-search-bar-facade';
import { PackageStep } from '@packages/packages-search-bar/constants/package-step';

@Component({
  selector: 'app-packages-search-bar',
  templateUrl: './packages-search-bar.container.html',
  styleUrls: ['./packages-search-bar.container.sass'],
  standalone: false
})
export class PackagesSearchBarContainer {

  @Input() searchType: SearchType;
  @Input() showHotelDetail: boolean;
  @Input() hotelDetail: HotelDetailResponse;
  @Input() source: EVENT_SOURCE | string;
  @Input() loadDefaultplaces: boolean;
  
  @Output() showMobileCalendarEvent: EventEmitter<CalendarField> = new EventEmitter<CalendarField>();

  constructor(
    private readonly mobileDeviceService: MobileDeviceService,
    private readonly facade: BaseSearchBarFacade,
  ) { 
    this.loadDefaultplaces = true;
  }  

  get isMobile$(): Observable<boolean> {
    return this.mobileDeviceService.isMobileDevice$;
  }

  get isFlightsResult$(): Observable<boolean> {
    return this.packageStep$.pipe(map(packageStep => (packageStep === PackageStep.FLIGHT_RESULTS && this.isResultsPage)));
  }

  private get packageStep$(): Observable<PackageStep> {
    return this.facade.packageStep$;
  }

  get isResultsPage(): boolean {
    return this.searchType === SearchType.PACKAGES_RESULT;
  }

}
